import { Box, Typography } from "@mui/material";
import { useAsyncError, useRouteError } from "react-router-dom";

export default function ErrorBoundaryNoDetails() {
    const routeError = useRouteError();
    const axiosError = useAsyncError();
    //console.log(routeError)
    return (
        <Box className='flex abs-center center-text fullwh'>
            <Box>
                {routeError && (
                    <>
                        <h1>Сталась помилка!</h1>
                        <h2>{routeError.status ?? routeError.response?.status}</h2>
                        <p>{routeError.statusText ?? routeError.response?.statusText}</p>
                        {routeError.data?.message && <p>{routeError.data.message}</p>}
                        {routeError.response?.message && <p>{routeError.response.message}</p>}

                    </>
                )}
                {axiosError && (
                    <>
                        <h1>Сталась помилка!</h1>
                        <h2>{axiosError.status ?? axiosError.response?.status}</h2>
                        <p>{axiosError.statusText ?? axiosError.response?.statusText}</p>
                        {axiosError.data?.message && <p>{axiosError.data.message}</p>}
                        {axiosError.response?.message && <p>{axiosError.response.message}</p>}
                    </>
                )}
                <a href='/'>
                    <Typography variant='h4' sx={{ fontWeight: 'bold' }}>
                        на головну
                    </Typography>
                </a>
            </Box>
        </Box >
    )
}